import Vue from 'vue';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';

export default Vue.extend({
  methods: {
    openEOPOverlayScreen(params) {
      const PROMISES = [
        this.$store.dispatch('getEOPDetails', params.transactionId),
        getContentArea('explanation-of-payment-appeal-rights'),
      ];
      LoadingService.watchPromises(PROMISES)
        .then((data) => {
          const CONTENT_AREAS = data[1];
          let paramsObj: any = {};
          if (CONTENT_AREAS && CONTENT_AREAS.fields) {
            paramsObj.appealRightsHeadline = CONTENT_AREAS.fields.title;
            paramsObj.appealRightsContent = CONTENT_AREAS.fields.content;
          }
          paramsObj = Object.assign(paramsObj, params);
          EventBus.$emit(
            'openOverlayWrapper',
            'ExplanationOfPaymentOverlay',
            paramsObj,
          );
        })
        .catch(() => {
          EventBus.$emit('openModal', 'Error', {
            message: 'global_connection-error',
          });
        });
    },
  },
});
